<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-if="theUserProject==0" v-model='theProjectId' @change="theProjectAllChange" size="small" clearable placeholder="请选择项目">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-button
          v-click.getDataOnlineProjectDailyList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
    </el-row>

    <mytable ref="getDataOnlineProjectDailyList"
      :tableColums='tableColums_getDataOnlineProjectDailyList'
      api='getDataOnlineProjectDailyList'
      xupdateapi='updateUser'
      :height="H-165" >
    </mytable> 

  </div>
</template>

<script>
export default {
  data() {
    return {
      userId: null,
      theProjectId:"",
      theUserProject:"",
      tableColums_getDataOnlineProjectDailyList: {
        $selection: false,
        dopdDate: '日期',
        projectName: '项目',
        dopdUserNum: '活跃人数',
        dopdVisitorNum: '今日拜访数量',
        dopdOrderNum: '订单数量',
        dopdOrderMoney: '订单金额',
      },

    };
  },

  watch: {
    
  },

  methods: {
    theProjectAllChange(e){
      this.theProjectId=e;
      this.getData();
    },
    getData(){
        if(this.theProjectId==0){
            this.theProjectId=null;
        }
        this.getDataOnlineProjectDailyList({projectId:this.theProjectId});
    }
  },

  created() {
    this.theUserProject=A.local('$projectId');
    if(this.theUserProject==0){
      this.getProjectList({pageSize:0});
    }else{
      this.theProjectId=this.theUserProject;
    }
    this.getData();
  },
  mounted(){
    
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/data/DataProjectDaily.vue